import React, { useState, useEffect } from "react";
import Spinner from "./Spinner";
import { useHistorialSolicitudes } from "../../cambios-contractuales/historial-solicitudes/useHistorialSolicitudes";
import { faClock, faCircleCheck, faCircleXmark, faCircleInfo, faUser, faArrowCircleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatFecha } from "../../utils/funciones";
import PropTypes from "prop-types";

export const Timeline = props => {
  const { id, volver } = props;
  const [events, setEvents] = useState([]);
  const { traerHistorial, historial } = useHistorialSolicitudes();

  Timeline.propTypes = {
    id: PropTypes.number.isRequired,
    volver: PropTypes.func.isRequired,
  };

  useEffect(() => {
    traerHistorial({ id });
  }, [id]);

  useEffect(() => {
    if (!historial) {
      return;
    }

    // 'historial' es el arreglo que obtienes directamente de resp.data.data del GET
    const eventos = historial.map(item => {
      // created_at viene del backend con formato "YYYY-MM-DD HH:mm:ss"
      const [datePart, timePart] = item.created_at ? item.created_at.split(" ") : ["", ""];

      return {
        status: item.estado_solicitud_cambio_contractual?.nombre || "Estado desconocido",
        date: datePart, // Ejemplo: "2026-07-13"
        time: timePart, // Ejemplo: "15:30:00"
        author: item.usuario?.nombre || item.nombre_completo_autor || "Usuario", // Nombre del usuario que aprobó/rechazó
        description: item.observaciones || "", // El motivo u observaciones del cambio
      };
    });

    setEvents(eventos);
  }, [historial]);

  const getStatusIconAndColor = statusName => {
    if (!statusName) return { icon: faCircleInfo, color: "#1976d2" };
    const lower = statusName.toLowerCase();
    if (lower.includes("aprobad") || lower.includes("aprobación")) return { icon: faCircleCheck, color: "#2e7d32" };
    if (lower.includes("rechazad")) return { icon: faCircleXmark, color: "#d32f2f" };
    return { icon: faCircleInfo, color: "#1976d2" };
  };

  return (
    <div className="position-relative ms-2 mb-2">
      {/* Vertical Line */}
      <div className="position-absolute" style={{ left: "15px", top: "10px", bottom: "10px", width: "2px", backgroundColor: "#e9ecef" }}></div>

      {historial === undefined && (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "240px" }}>
          <Spinner clases="m-0" />
        </div>
      )}

      {historial !== undefined && events?.length > 0 && (
        <>
          {events.map((item, index) => {
            const { icon, color } = getStatusIconAndColor(item.status);
            const itemId = Number.parseInt(index, 10);

            return (
              <div key={itemId} className="position-relative mb-4" style={{ paddingLeft: "45px" }}>
                <div className="position-absolute bg-white rounded-circle d-flex justify-content-center align-items-center" style={{ left: "0", top: "0", width: "32px", height: "32px", border: `2px solid ${color}`, color: color, zIndex: 1 }}>
                  <FontAwesomeIcon icon={icon} />
                </div>

                <div className="card shadow-sm border-0 rounded-3">
                  <div className="card-body p-3">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <div>
                        <h6 className="fw-bold m-0 mb-1" style={{ color: color }}>
                          {item.status}
                        </h6>
                        <div className="text-muted small">
                          <FontAwesomeIcon icon={faUser} className="me-1" />
                          {item.author || "Autor desconocido"}
                        </div>
                      </div>
                      <div className="text-muted small d-flex align-items-center gap-1">
                        <FontAwesomeIcon icon={faClock} />
                        {item.date ? formatFecha(item.date) : ""} {item.time}
                      </div>
                    </div>
                    {item.description && (
                      <div className="p-2 mt-2 bg-light rounded text-muted" style={{ fontSize: "0.9rem", borderLeft: "3px solid #dee2e6" }}>
                        <em style={{ whiteSpace: "pre-wrap" }}>{item.description}</em>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </>
      )}

      {historial !== undefined && events?.length === 0 && (
        <div className="text-center text-muted" style={{ minHeight: "240px", display: "flex", justifyContent: "center", alignItems: "center" }}>
          No se encontró historial.
        </div>
      )}

      <div className="w-100 justify-content-end d-flex">
        <button className="btn btn-light px-4 py-2 fw-bold rounded-pill d-flex align-items-center shadow-sm transition-all" style={{ color: "#2a77b9", border: "1px solid #cce0f0" }} title="Ver historial" onClick={volver}>
          <span className="me-2">Volver</span> <FontAwesomeIcon icon={faArrowCircleLeft} />
        </button>
      </div>
    </div>
  );
};
